import { acceptUserTos, spotifyRefreshToken } from "@api/index";
import { Button, Container, Typography } from "@mui/material";
import React from "react";
import ReactMarkdown from "react-markdown";
import { useNavigate } from "react-router-dom";
import { useConfigContext } from "src/ConfigProvider";

const TosPage: React.FC = () => {
  const navigate = useNavigate();
  const configs = useConfigContext();
  const handleAccept = async () => {
    // Handle accept terms of service
    console.log("Terms of Service accepted");
    await acceptUserTos();
    await spotifyRefreshToken();
    navigate("/");
  };

  return (
    <Container>
      <Typography variant="h4" gutterBottom>
        Terms of Service
      </Typography>
      <ReactMarkdown>{configs.config?.tos}</ReactMarkdown>

      <Button variant="contained" color="primary" onClick={handleAccept}>
        Accept
      </Button>
    </Container>
  );
};

export default TosPage;
